/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { VariationBadge } from 'cio/models/action';
import { SplitMetric } from 'cio/utils/metrics/models/split-metric';
import { findDenominator, MeasureType } from 'cio/utils/metrics/measure';

interface CampaignSplitPerformanceTableArgs {
  availableMeasures: { key: string; title: string }[];
  originalMetric: SplitMetric;
  originalBadge: VariationBadge;
  variationMetrics: {
    metric: SplitMetric;
    badge: VariationBadge;
  };
}

export default class CampaignSplitPerformanceTable extends Component<CampaignSplitPerformanceTableArgs> {
  get denominator() {
    return findDenominator('converted', MeasureType.DeliveryMetrics, 'email_action');
  }
}
